// ============================================================================
// Reservation Modification Service
// Typed wrappers around the modify / site-change / rebook endpoints used by
// ModificationWizard and the schedule grid's quick-action (click-to-extend,
// drag-and-drop) interactions.
// ============================================================================

import managerApi from './auth/managerApi';
import {
  ModificationPreviewRequest,
  ModificationPreview,
  ModifyRequest,
  ModifyResult,
  SiteChangePreviewRequest,
  SiteChangeRequest,
  RebookPreviewRequest,
  RebookRequest,
  AvailableSite,
} from '../types';

export const getModifyPreview = (
  reservationId: number,
  body: ModificationPreviewRequest
): Promise<ModificationPreview> => {
  return managerApi.post(`/reservations/${reservationId}/modify-preview`, body);
};

export const executeModify = (
  reservationId: number,
  body: ModifyRequest
): Promise<ModifyResult> => {
  return managerApi.post(`/reservations/${reservationId}/modify`, body);
};

export const getSiteChangePreview = (
  reservationId: number,
  body: SiteChangePreviewRequest
): Promise<ModificationPreview> => {
  return managerApi.post(`/reservations/${reservationId}/site-change-preview`, body);
};

export const executeSiteChange = (
  reservationId: number,
  body: SiteChangeRequest
): Promise<ModifyResult> => {
  return managerApi.post(`/reservations/${reservationId}/site-change`, body);
};

export const getRebookPreview = (
  reservationId: number,
  body: RebookPreviewRequest
): Promise<ModificationPreview> => {
  return managerApi.post(`/reservations/${reservationId}/rebook-preview`, body);
};

export const executeRebook = (
  reservationId: number,
  body: RebookRequest
): Promise<ModifyResult> => {
  return managerApi.post(`/reservations/${reservationId}/rebook`, body);
};

export const getAvailableSites = async (
  storeId: number,
  checkIn: string,
  days: number,
  excludeReservationId: number
): Promise<AvailableSite[]> => {
  const params = new URLSearchParams({
    store_id: storeId.toString(),
    check_in: checkIn,
    days: days.toString(),
    exclude_reservation_id: excludeReservationId.toString(),
  });
  const data = await managerApi.get(`/reservations/available-sites?${params}`);
  return data.available_sites || [];
};
